import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { monochrome } from '../../theme/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    checkboxLabel: {
      fontWeight: 600,
      fontSize: '15px',
      lineHeight: '24px',
      color: theme.palette.type === 'dark' ? monochrome.light : monochrome.dark,
    },
    disabledLabel: {
      opacity: 0.5,
    },
    dialogPaper: {
      overflowX: 'hidden',
      // Wide enough for the location and shift grids; maxWidth="md" alone would be 960px
      maxWidth: 800,
    },
    // The theme forces 20px on every Typography inside MuiDialogTitle; the nested selectors
    // below match its specificity so the title and subtitle keep their own sizes
    titleRoot: {
      padding: '24px 32px 0',
      '& $title': {
        fontSize: 20,
        lineHeight: '28px',
        fontWeight: 600,
      },
      '& $subtitle': {
        fontSize: 15,
        lineHeight: '22px',
        marginTop: 4,
      },
    },
    title: {},
    subtitle: {},
    content: {
      paddingTop: 4,
      // The theme gives DialogContent no bottom padding — keep the list off the footer border
      paddingBottom: 16,
    },
    tabs: {
      minHeight: 40,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    tab: {
      textTransform: 'none',
      fontSize: 15,
      fontWeight: 600,
      minWidth: 'auto',
      minHeight: 40,
      padding: '6px 12px',
    },
    actions: {
      // Same horizontal padding as the title and content so the footer text lines up
      padding: '16px 32px',
      borderTop: `1px solid ${theme.palette.divider}`,
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 12,
    },
    footerText: {
      fontSize: 14,
      color: theme.palette.text.secondary,
    },
    footerStrong: {
      color: theme.palette.text.primary,
      fontWeight: 600,
    },
    countRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minHeight: 32,
    },
    linkButton: {
      fontWeight: 600,
      fontSize: 13,
      textTransform: 'none',
      padding: '2px 8px',
      minWidth: 'auto',
    },
    hint: {
      fontSize: 13,
      color: theme.palette.text.secondary,
    },
    sectionTitle: {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '24px',
      color: theme.palette.text.primary,
    },
    sectionCaption: {
      fontSize: 14,
      color: theme.palette.text.secondary,
    },
    sectionError: {
      fontSize: 14,
      color: theme.palette.error.main,
    },
    summaryContent: {
      margin: '8px 0 !important',
    },
    // The theme strips every Accordion of its border and padding, so each module on the
    // "Where" step draws its own card to stay distinguishable from its neighbours
    moduleCard: {
      border: `1px solid ${theme.palette.divider}`,
      // Beats MUI's first-child / last-child radius rules
      borderRadius: '12px !important',
      padding: '0 16px',
      // The WhereStep gridGap already spaces the cards, expanded or not
      margin: '0 !important',
      backgroundColor: theme.palette.background.paper,
      transition: theme.transitions.create('border-color'),
      '&$moduleCardExpanded': {
        borderColor: theme.palette.primary.main,
      },
    },
    moduleCardExpanded: {},
    moduleIcon: {
      width: 36,
      height: 36,
      borderRadius: 8,
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.action.hover,
    },
    moduleDetails: {
      borderTop: `1px solid ${theme.palette.divider}`,
      padding: '12px 0 16px',
    },
    detailsTitle: {
      color: theme.palette.type === 'dark' ? monochrome.light : monochrome.dark,
      fontSize: '15px',
      fontWeight: 400,
    },

    addButton: {
      color: theme.palette.primary.main,
    },
    divider: {
      flex: 1,
      height: 2,
    },
    or: {
      margin: '0 16px',
      color: theme.palette.type === 'dark' ? monochrome.light : monochrome.dark,
      fontWeight: 600,
      fontSize: '15px',
    },
    more: {
      fontWeight: 600,
      fontSize: '13px',
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
    errorText: {
      color: theme.palette.error.main,
      lineHeight: '24px',
      marginTop: '1px',
    },
    moduleName: {
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
    dialogText: {
      fontSize: '18px',
      color: theme.palette.type === 'dark' ? monochrome.light : monochrome.dark,
    },
  })
);
